import { render, staticRenderFns } from "./_SupplierNameColumn.vue?vue&type=template&id=135ccd89"
import script from "./_SupplierNameColumn.vue?vue&type=script&lang=js"
export * from "./_SupplierNameColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports